import { VideoScriptPanel } from "../components/VideoScriptPanel/index";
import { useVideoReview } from "./hooks";
import { useEffect } from "react";
import { useOpenWindow } from "@utils/window";
import Empty from "../components/Empty";
import "./index.scss";
import { PageHeader } from "@layouts/PageHeader";

export const ScriptReview = () => {
  const { openWindow } = useOpenWindow();

  const {
    status,
    rewriteScriptList,
    collectionDetail,
    requestVideoScripteMulation,
    showTranslate,
    isBasicUp,
    setCollectionDetail,
    collectionId,
  } = useVideoReview();

  useEffect(() => {
    if (collectionDetail?.requestId || collectionDetail?.uuid) {
      const { id, translate, uuid, requestId } = collectionDetail || {};
      requestVideoScripteMulation({ id, translate, requestId: requestId || uuid });
    }
  }, [collectionDetail?.requestId, collectionDetail?.uuid]);

  if (!isBasicUp || collectionDetail?.error) {
    return (
      <Empty
        image="8903ffad.png"
        tips={collectionDetail?.error || "Sorry, You don't have permission to access this page."}
        label="Back to homepage"
        className="flex-1"
        handleBtnClick={() => {
          openWindow("/");
        }}
      />
    );
  }

  // 测试按钮，开发时可手动切换状态
  return (
    <div className="ScriptReview h-screen relative">
      <PageHeader title={collectionDetail.name} allowClickThrough></PageHeader>
      <VideoScriptPanel
        showProduct
        data={[{ collectionId, ...collectionDetail, ...rewriteScriptList[collectionDetail.activeScript - 1] }]}
        className="-mt-[53px]"
        status={status}
        handleTranslate={showTranslate}
        handleSave={setCollectionDetail}
      />
    </div>
  );
};
